// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"720":"f7807c04","908":"bfaec1cf"}[chunkId] + ".chunk.js";
};